module.exports = "/_next/static/images/GOER-Mirnawati-1dec1309e583c9e711237d01a7f0b786.svg";